 /* eslint-disable */

import barba from '@barba/core';
import { gsap } from 'gsap';
import MenuApp from '../components/menuApp';
import PhotoSwipeController from '../components/photoSwipeController';
/*require('cookieconsent');*/

export default {
	init() {

		// JavaScript to be fired on all pages
		var ajax_url = window.ajax_object.ajax_url;

		document.addEventListener( 'wpcf7mailsent', function(event) {
			console.log('partito');
			_iub.cons_instructions.push(["submit", {
				submitElement: document.getElementById("cf7_submit"),
				writeOnLocalStorage: false, // default: false
				form: {
				selector: document.getElementById("cf7_form"),
				map: {
					subject: {
						first_name: "nome",
						last_name: "cognome",
						email: "email"
					},
					preferences: {
						privacy: "privacy",
						}
					}
				},
				consent: {
					legal_notices: [
					{      
					identifier: 'privacy_policy',    
					},{
					identifier: 'cookie_policy',
					},{
					identifier: 'term',
					}
				],
				}
			},{
			success: function(response) {
				console.log(response);
				}, 
			error: function(response) {
				console.log(response);
				}
			}
			]);
		});
	


		/*window.cookieconsent.initialise({
			'palette': {
				'popup': {
					'background': '#163445',
				},
				'button': {
					'background': '#ffffff',
					'text': '#163445',
				},
			},
			'position': 'bottom-right',
			'content': {
				'dismiss': 'OK',
				'message': window.textBannerPrivacy,
				'link': window.linkBannerPrivacyLabel,
				'href': window.linkBannerPrivacyUrl,
			},
		});*/

		$('body.front-page-data').find('.banner').eq(0).find('a').click(function(){

			// window.gtag('event', 'click', {
			// 	'event_category': 'button',
			// 	'event_label': 'acquista ora - 1',
			// });

		});

		$('body.front-page-data').find('.banner').eq(1).find('a').click(function(){

			// window.gtag('event', 'click', {
			// 	'event_category': 'button',
			// 	'event_label': 'acquista ora - 2',
			// });

		});

		$('body.front-page-data').find('.banner').eq(2).find('a').click(function(){

			// window.gtag('event', 'click', {
			// 	'event_category': 'button',
			// 	'event_label': 'acquista ora - 3',
			// });

		});


		if($('.wpcf7').length > 0){

			var wpcf7ElmContatti = document.querySelector( '.wpcf7' );

			wpcf7ElmContatti.addEventListener( 'wpcf7submit', function() {


				// window.gtag('event', 'click', {
				// 	'event_category': 'form',
				// 	'event_label': 'completamento form contatti',
				// });

			}, false );

		}

		// Site
		if($('.wrapper-site').length > 0) {

			// Hamburger
			$('#hamburger').click(function() {
				$(this).toggleClass('open');
				$('.bg-nav-mobile').slideToggle();
			});
			$('.nav-mobile a').click(function() {
				$('.bg-nav-mobile').slideUp();
				$('#hamburger').removeClass('open');
			});

			// Desktop fixed header
			$(window).scroll(function(){
				if ($(window).scrollTop() >= 130) {
					$('header nav, body').addClass('fixed-header');
				} else {
					$('header nav, body').removeClass('fixed-header');
				}
			});
		}

		//let menuApp = null;
		if($('.nav-app-aside').length > 0){

			var menuApp = new MenuApp();
			menuApp.setCurrentCapitolo($('.content-capitoli.show').attr('id'));

		}

		if($('body').hasClass('webapp')){

			new PhotoSwipeController();

			barba.init({
				sync: true,
				debug: false,
				cacheIgnore: ['/profilo-utente/'],
				timeout: 15000,
				prevent: ({ el }) => el.classList && (el.classList.contains('ab-item') || el.classList.contains('no-barba')),
				transitions: [{
					name: 'default-transition',
					leave(data) {
					//leave() {

						//$( '.barba' ).addClass( 'change' );

						if($('#btn-indice-mobile').hasClass('open'))
							$('#btn-indice-mobile').click();

						$(data.current.container).hide();
						$(data.current.container).height(0);

						$( '.app-wrap-content' ).addClass( 'change' );
						return gsap.to('.barba-loader', {
							width: '100%',
							right: 'auto',
							left: '0',
						});

						// return gsap.to(data.current.container, {
						// 	opacity: 0,
						// });

					},
					enter(data) {
					//enter() {
						//console.log(data.next.url.hash);

						$( '.barba-loader' ).css( {left: 'auto'} );
						gsap.to('.barba-loader', {
							right: '0',
							width: '0',
							onComplete: function(){
								//new PhotoSwipeController();
								$( '.app-wrap-content' ).removeClass( 'change' );
								$( '.barba-loader' ).css( {left: '0'} );
							},
						});


						return gsap.from(data.next.container, {
							opacity: 0,
							onComplete: function(){
								new PhotoSwipeController();
							},
						});




						// return gsap.from(data.next.container, {
						// 	opacity: 0,
						// 	onComplete: function(){
						// 		new PhotoSwipeController();
						// 	},
						// });



						// execute above function
						//initPhotoSwipeFromDOM('.my-gallery');
						//new PhotoswipeController();

					},
					afterEnter(data) {

						console.log(data.trigger);
						console.log($(data.trigger).attr('data-id-post'));


						let triggetPostId = $(data.trigger).attr('data-id-post');
						if($('#wpadminbar').length > 0 && triggetPostId != '' && triggetPostId != undefined){

							let linkEditPost = $('#wp-admin-bar-edit a').attr('href');
							let newLinkEditPost = linkEditPost.replace(/([0-9]+)/g, triggetPostId);
							$('#wp-admin-bar-edit a').attr('href',newLinkEditPost);
						}



						//console.log($(data.next.html).find('#indice').find('.content-capitoli.show').attr('id'));

						//console.log($('.wrap-barba').length, $('.wrap-barba').lastChild());
						//$('body .wrap-barba:last-child').find('.content-capitolo .paragraph-wrap').each(function () {
						//$(data.next.html).find('.content-capitolo .paragraph-wrap').each(function () {

						// $('.wrap-barba').last().find('.content-capitolo .paragraph-wrap').each(function () {
						//
						// 	console.log('IN AFTER ENTER EIGHT ::' , $(this).height(), $(this).find('.paragrafo-capitolo').html());
						//
						// });

						menuApp.setFromDomLinkCapitoloPrevNext($(data.next.html));
						let currCapitolo = $(data.next.html).find('#indice').find('.content-capitoli.show').attr('id');
						menuApp.setCurrentCapitolo(currCapitolo);
						menuApp.setLabelNavIndicatorMobile();

						if(data.next.url.hash != undefined)
							$('.paragrafo-nav[data-slug-paragraph="'+data.next.url.hash+'"]').click();
					},
				}],
			});

			barba.hooks.after(() => {
				//Tracking GA app
				// window.gtag('config', window.gtagId, {'page_path': window.location.pathname,'page_title' : document.title});
			});

			barba.hooks.afterEnter(() => {
				//User profile edit form
				if ($('.profile-wrap form').length) {
					attachSubmitFormEditUser();
				}
				console.log('afterEnter Fired');
			});

			$('.search-form').submit(function(e){
				e.preventDefault();
				//console.log(e);
				let urlToGoSearch = '/?s='+$('#search-field').val();
				barba.go(urlToGoSearch);

			});

			//barba.go(href: string, trigger?: Trigger, e?: LinkEvent | PopStateEvent)

		}

		function attachSubmitFormEditUser() {
			$('.profile-wrap form input').on('input', function () {
				$('.profile-wrap form').find(':submit').attr('disabled', false);
			});
			$('.profile-wrap form').submit(function (e) {
				e.preventDefault();

				let feedBox = $(this).find('.form-feed');

				feedBox.hide();
				feedBox.html('');
				feedBox.removeClass('valid');
				feedBox.removeClass('not-valid');

				$(this).find('.errore').toggleClass('errore');

				let control = true;
				let firstname = $(this).find('input[name="firstname"]');
				let lastname = $(this).find('input[name="lastname"]');
				let email = $(this).find('input[name="email"]');

				let nonce = $(this).find('input[name="_ajax_nonce"]');

				if (firstname.val() == '' || firstname.val().length < 2) {
					firstname.addClass('errore');
					control = false;
				}
				if (lastname.val() == '' || lastname.val().length < 2) {
					lastname.addClass('errore');
					control = false;
				}
				if (email.val() == '' || !(validateMail(email.val()))) {
					email.addClass('errore');
					control = false;
				}

				if (nonce.val() == '') {
					control = false;
				}

				if (!control) {

					feedBox.addClass('not-valid');
					feedBox.html('In uno o più campi si sono verificati degli errori. Per favore, controlla i campi e riprova.');
					feedBox.slideDown();

					return false;

				} else {
					$(this).find(':submit').attr('disabled', true);
					$.ajax({
						'type': 'POST',
						'url': ajax_url,
						'data': $(this).serialize(),
					}).success(function (r) {
						if (r.success) {
							feedBox.addClass('valid');
							$('.profile-wrap .user-name').html(firstname.val() + ' ' + lastname.val());
							$('#profile .user-info .user-name').html(firstname.val() + ' ' + lastname.val());
							$('#profile .user-info .user-email').html('(' + email.val() + ')');
						} else {
							feedBox.addClass('not-valid');
						}
						feedBox.html(r.data.message);
						feedBox.slideDown();
						$('.profile-wrap form').find(':submit').attr('disabled', false);
					});
				}
			});
		}

		function validateMail(email) {
			/* eslint-disable */
			let emailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			/* eslint-enable */
			return emailCheck.test(email);
		}


		$('#riscattocodiceform').submit(function (e) {
			e.preventDefault();


			let loader = $(this).find('.loading-form-code');
			loader.show();
			let feedBox = $(this).find('.form-feed');

			feedBox.hide();
			feedBox.html('');
			feedBox.removeClass('valid');
			feedBox.removeClass('not-valid');

			$(this).find('.errore').toggleClass('errore');

			let control = true;

			let code = $(this).find('input[name="codice"]');
			//let pass = $(this).find('input[name="user_pass"]');
			let email = $(this).find('input[name="user_login"]');

			let nonce = $(this).find('input[name="_ajax_nonce"]');



			// if (pass.val() == '' || pass.val().length < 2) {
			// 	pass.addClass('errore');
			// 	control = false;
			// 	console.log('1');
			// }

			//console.log(code);

			if (code.val() == '' || code.val().length < 16 || code.val().length > 16) {
				code.addClass('errore');
				control = false;
				console.log('2');
			}

			if (email.val() == '' || !(validateMail(email.val()))) {
				email.addClass('errore');
				control = false;
				console.log('3');
			}

			if (nonce.val() == '') {
				control = false;
				console.log('4');
			}

			if (!control) {

				feedBox.addClass('not-valid');
				feedBox.html('In uno o più campi si sono verificati degli errori. Per favore, controlla i campi e riprova.');
				feedBox.slideDown();
				loader.hide();

				return false;

			} else {
				$(this).find(':submit').attr('disabled', true);
				$.ajax({
					'type': 'POST',
					'url': ajax_url,
					'data': $(this).serialize(),
				}).success(function (r) {
					loader.hide();

					if (r.success) {
						feedBox.addClass('valid');
						// $('.profile-wrap .user-name').html(firstname.val() + ' ' + lastname.val());
						// $('#profile .user-info .user-name').html(firstname.val() + ' ' + lastname.val());
						// $('#profile .user-info .user-email').html('(' + email.val() + ')');
						code.val('');
						email.val('');
						nonce.val('');

						console.log('success');
					} else {
						feedBox.addClass('not-valid');
					}
					feedBox.html(r.data.message);
					feedBox.slideDown();
					$('#riscattocodiceform').find(':submit').attr('disabled', false);
				});
			}

		});


	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js